import { AxiosResponse } from "axios";
import { httpRequest } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { Patient, PatientsResponse } from "@/types";

async function fetchPatients(
  page?: string | null,
  per_page?: number | null,
  search?: string | null,
  covenantId?: string | null,
  gender?: string | null,
  birthday?: string | null
): Promise<PatientsResponse> {
  const pageParams = !per_page
    ? `page=${page || 1}`
    : `page=${page || 1}&per_page=${per_page}&search=${
        search ?? ""
      }&covenantId=${covenantId ?? ""}&gender=${gender ?? ""}&birthday=${
        birthday ?? ""
      }`;
  const patients = await httpRequest.get<PatientsResponse>(
    `/patients?${pageParams}`
  );
  return patients.data;
}

export function useFetchPatientsQuery({
  page,
  per_page,
  search,
  covenantId,
  gender,
  birthday,
}: {
  page?: string | null;
  per_page?: number | null;
  search?: string | null;
  covenantId?: string | null;
  gender?: string | null;
  birthday?: string | null;
}) {
  const patientsQuery = useQuery({
    queryKey: [
      "patients",
      page || "1",
      per_page,
      search,
      covenantId,
      gender,
      birthday,
    ],
    queryFn: () =>
      fetchPatients(page, per_page, search, covenantId, gender, birthday),
    keepPreviousData: true,
  });

  return {
    ...patientsQuery,
    data: patientsQuery?.data,
  };
}

async function fetchPatientsNoPaginate(): Promise<AxiosResponse<Patient[]>> {
  return await httpRequest.get<Patient[]>(`/list/patients`);
}

export function useFetchPatientsNoPaginateQuery() {
  const covenantsQuery = useQuery({
    queryKey: ["patients"],
    queryFn: () => fetchPatientsNoPaginate(),
    keepPreviousData: true,
  });

  return {
    ...covenantsQuery,
    data: covenantsQuery?.data?.data,
  };
}
